import apiClient from '@/services/axios'

export async function get(role, venueId) {
    var response = await apiClient.get(`/Idam/RoleLookup/${role}/${venueId}`)
    if (response) {
        return response.data
    }

    throw new Error('Unable to get users for ', role)
}
